import {client} from './services/client'

export  const historiques = {
    namespaced:true,
    state:{
        historiques:[],
        historiqueloading:true,
    },
    mutations: {
        SET_HISTORIQUE (state,historiques){
            state.historiques = historiques
        },
        SET_HISTORIQUELOADING (state,historiques){
            state.historiqueloading = historiques
        },


    },
    actions: {
        getHistoriques({commit},id){
            commit('SET_HISTORIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/historiques/get/'+id,
                })
                    .then((response)=>{
                        let historiques = response.data.historiques;
                        console.log(historiques);
                        commit('SET_HISTORIQUE',historiques)
                        commit('SET_HISTORIQUELOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setUpdateHistorique({commit},data){
            commit('SET_HISTORIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/historiques/update',
                    data:data,
                })
                    .then((response)=>{
                        let historiques = response.data.historiques;
                        commit('SET_HISTORIQUE',historiques);
                        commit('SET_HISTORIQUELOADING',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setHistorique({commit},data){
            commit('SET_HISTORIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/historiques/save',
                    data:data,
                })
                    .then((response)=>{
                        let historiques = response.data.historiques;
                        commit('SET_HISTORIQUE',historiques);
                        commit('SET_HISTORIQUELOADING',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteHistorique({commit},id){
            commit('SET_HISTORIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/historiques/delete/'+id,
                })
                    .then((response)=>{
                        let historiques = response.data.historiques;
                        commit('SET_HISTORIQUE',historiques);
                        commit('SET_HISTORIQUELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getHistoriques: state  => {
            return state.historiques
        },
    }
};
